/**
 * Default/neutral input state
 */
export function createDefaultInput() {
    return {
        thrust: 0,
        rotation: 0,
        aimAngle: 0,
        shooting: false,
    };
}
/**
 * Keyboard key bindings
 */
export const KEY_BINDINGS = {
    thrustForward: ['KeyW', 'ArrowUp'],
    thrustBackward: ['KeyS', 'ArrowDown'],
    rotateLeft: ['KeyA', 'ArrowLeft'],
    rotateRight: ['KeyD', 'ArrowRight'],
    shoot: ['Space', 'Enter'],
};
/**
 * Gamepad button/axis mappings
 */
export const GAMEPAD_BINDINGS = {
    thrustAxis: 1, // Left stick Y (inverted)
    rotateAxis: 0, // Left stick X
    aimXAxis: 2, // Right stick X
    aimYAxis: 3, // Right stick Y
    shootButton: 7, // Right trigger
    shootButtonAlt: 5, // Right bumper
};
/**
 * Deadzone for analog stick input
 */
export const STICK_DEADZONE = 0.15;
//# sourceMappingURL=input.js.map